export const INITIAL_GDN_TAGS = Object.freeze({"tag-0": "hashtag", "tag-1": "tag", "tag-2": "tag", "tag-3": "tag"});
export const INITIAL_GDN_TAG_ORDER = Object.freeze(Object.keys(INITIAL_GDN_TAGS));

export type GdnTagRecord = Record<string, unknown>;

const GDN_TAG_ID_PATTERN = /^tag-(0|[1-9]\d*)$/;

export function assertGdnTagId(value: unknown): asserts value is string {
  if (typeof value !== "string" || !GDN_TAG_ID_PATTERN.test(value)) {
    throw new Error(`Invalid GDN tag id: ${String(value)}`);
  }
}

export function assertGdnTagRecord(value: unknown): asserts value is GdnTagRecord {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    throw new Error("Invalid GDN tags: expected an object");
  }
  for (const id of Object.keys(value)) assertGdnTagId(id);
}

export function normalizeGdnTagOrder(value: unknown, tags: GdnTagRecord): string[] {
  if (value === undefined) return Object.keys(tags);
  if (!Array.isArray(value)) {
    throw new Error("Invalid GDN tag order: expected an array");
  }

  const seen = new Set<string>();
  return value.map((id) => {
    assertGdnTagId(id);
    if (seen.has(id)) throw new Error(`Duplicate GDN tag id: ${id}`);
    if (!Object.prototype.hasOwnProperty.call(tags, id)) {
      throw new Error(`GDN tag order references missing tag: ${id}`);
    }
    seen.add(id);
    return id;
  });
}

export function nextGdnTagId(tags: GdnTagRecord): string {
  const indexes = Object.keys(tags).map((id) => {
    assertGdnTagId(id);
    return Number(id.slice(4));
  });
  return `tag-${indexes.length === 0 ? 0 : Math.max(...indexes) + 1}`;
}
